import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { asFormElement, Label, GenericInput } from "@we.org/react-forms";

import { NAMESPACE } from "../../namespace";
import "./LabelledInput.css";

class LabelledInput extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
  };

  static defaultProps = {
    className: "",
  };

  render() {
    const { children, className, ...rest } = this.props;

    return (
      <Label className={`${NAMESPACE}LabelledInput ${className}`.trim()}>
        <div className="label">{children}</div>
        <GenericInput {...rest} className="input" />
      </Label>
    );
  }
}

export default asFormElement(LabelledInput);
